<template>
	<div class="h-footer">
		<div class="h-footerIn">
			<p>Copyright Haier 2019. All rights reserved</p>
		</div>
	</div>
</template>

<script>
export default {
	name:'Commonfooter',
}
</script>

<style>
</style>
